<template>
  <div v-if="visible" class="onboarding-loading-overlay">
    <div class="onboarding-loading-spinner">
      <div class="spinner"></div>
      <p v-if="message" class="loading-message">{{ message }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',

  props: {
    show: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ''
    },
    hidePercent: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      visible: false,
      simulatedProgress: 0
    }
  },

  watch: {
    show: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this._startProgress()
        } else {
          this._completeProgress()
        }
      }
    }
  },

  methods: {
    _startProgress() {
      this.simulatedProgress = 0
      this.visible = true
      this._stopProgress()
      this._progressTimer = setInterval(() => {
        if (this.simulatedProgress < 80) {
          const step = Math.max(1, Math.round((80 - this.simulatedProgress) * 0.08))
          this.simulatedProgress = Math.min(80, this.simulatedProgress + step)
        }
      }, 100)
    },

    _completeProgress() {
      this._stopProgress()
      if (!this.visible) return
      this.simulatedProgress = 100
      setTimeout(() => {
        this.visible = false
        this.simulatedProgress = 0
      }, 350)
    },

    _stopProgress() {
      if (this._progressTimer) {
        clearInterval(this._progressTimer)
        this._progressTimer = null
      }
    }
  },

  beforeDestroy() {
    this._stopProgress()
  }
}
</script>

<style scoped lang="scss">
.onboarding-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(1.5px);
  transition: opacity 0.25s ease;
}

.onboarding-loading-spinner {
  text-align: center;
  color: white;
  max-width: 420px;
  padding: 0 20px;

  .spinner {
    width: 44px;
    height: 44px;
    border: 4px solid rgba(255, 255, 255, 0.25);
    border-top: 4px solid white;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin: 0 auto 14px;
  }

  .loading-percent {
    display: block;
    font-size: 20px;
    font-weight: 600;
    letter-spacing: 1px;
    line-height: 1;
    opacity: 0.9;
    margin-left: 4px;
  }

  .loading-message {
    margin-top: 14px;
    font-size: 15px;
    font-weight: 500;
    letter-spacing: 0.2px;
    line-height: 1.4;
    opacity: 0.95;
    color: #ffffff;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
